import {
  PageGen,
  PdfRect,
  PdfUnit,
  PdfBrush,
  PdfColor,
  PdfPen,
  PdfPoint,
  ETextAlign,
} from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaSky implements IColorSchema {
  readonly name = 'Sky';

  private sizeTopHeader = PdfUnit.FromMillimeters(12);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);
  private sizeTopMargin = PdfUnit.FromMillimeters(2);
  private sizeBottomMargin = PdfUnit.FromMillimeters(4);

  private skyBlue = PdfColor.fromRgb(135, 206, 235);
  private cloudColor = PdfColor.fromRgb(255, 255, 255);
  private resultBg = PdfColor.fromRgb(240, 248, 255);

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `- ${pageNumber} -`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    let left = rect.x;
    const top = (this.sizeTopHeader - this.sizeTopTitle) / 2;

    // Soft sky header
    const headerRect = new PdfRect(rect.x, rect.y + top, rect.width, this.sizeTopTitle);
    page.drawRoundedRectangle(
      new PdfPen(this.skyBlue, 1),
      null,
      headerRect,
      PdfUnit.FromMillimeters(4)
    );

    if (counter) {
      // Cloud counter
      const cloudRect = new PdfRect(
        left - PdfUnit.FromMillimeters(2),
        rect.y,
        this.sizeTopHeader * 1.4,
        this.sizeTopHeader
      );
      page.drawCloud(cloudRect, new PdfBrush(this.skyBlue), null);
      page.drawString(counter, font, PdfBrush.Black, null, cloudRect, ETextAlign.Center);
      left += cloudRect.width + this.marginTop;
    }

    if (title) {
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.CenterLeft);
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    page.drawRectangle(null, new PdfBrush(this.resultBg), rect);
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x,
      rect.y + this.sizeTopHeader + this.sizeTopMargin,
      rect.width,
      rect.height - this.sizeTopHeader - this.sizeBottomMargin
    );
  }
}
